import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const CompanyList = Loadable(lazy(() => import("./CompanyList")));
const CompanyForm = Loadable(lazy(() => import("./CompanyForm")));

const companyRoutes = [
  {
    path: "/Company/CompanyList",
    element: <CompanyList />,
    permission: PERMISSIONS.Companys.Menu,
  },
  {
    path: "/Company/CompanyForm",
    element: <CompanyForm />,
  },
  {
    path: "/Company/CompanyForm/:companyId",
    element: <CompanyForm />,
  },
];

export default companyRoutes;
